import { getRequestHeaders, handleRes, logError } from "utils";
import { Contact } from "types";

interface GetContactsParams {
  tenantID: string | number | undefined;
  contactID: string | number | undefined;
}
export const getContact = ({
  tenantID,
  contactID,
}: GetContactsParams): Promise<Contact> => {
  return fetch(
    `${window.USER_BASE_URL}/tenant/${tenantID}/contacts/${contactID}`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Contact>(res, 200))
    .catch((e) => {
      throw e;
    });
};

interface CreateContactParams {
  tenantID: string | number | undefined;
  body: string; // JSON string of Contact
}
export const createContact = async ({
  tenantID,
  body,
}: CreateContactParams): Promise<Response> => {
  return await fetch(`${window.USER_BASE_URL}/tenant/${tenantID}/contacts`, {
    method: "POST",
    ...getRequestHeaders(),
    body,
  });
};
export interface UpdateContactParams {
  body: string; // JSON string of Contact
  tenantID: string | number | undefined;
  contactID: string | number | undefined;
}
export const updateContact = async ({
  body,
  tenantID,
  contactID,
}: UpdateContactParams): Promise<Response> => {
  return await fetch(
    `${window.USER_BASE_URL}/tenant/${tenantID}/contacts/${contactID}`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface GetTenantContactsParams {
  tenantID: string | number | undefined;
  search?: string;
  type?: "name" | "phone" | undefined;
}
export const getTenantContacts = ({
  tenantID,
  search,
  type,
}: GetTenantContactsParams): Promise<Contact[]> => {
  let phone = "";
  let name = "";
  if (type === "name" && search) {
    name = search;
  } else if (type === "phone" && search) {
    phone = search;
  }
  return fetch(
    `${window.USER_BASE_URL}/tenant/${tenantID}/contacts?name=${name}&phone=${phone}`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Contact[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};

interface PutPropertyContactsParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
  body: string; // JSON string of Contact[]
}
export const putPropertyContacts = async ({
  tenantID,
  propertyID,
  body,
}: PutPropertyContactsParams): Promise<Response> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/contacts`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface PutPropertyGroupContactsParams {
  tenantID: string | number | undefined;
  groupID: string | number | undefined;
  body: string; // JSON string of Contact[]
}
export const putPropertyGroupContacts = async ({
  tenantID,
  groupID,
  body,
}: PutPropertyGroupContactsParams): Promise<Response> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/propertyGroups/${groupID}/contacts`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface GetPropertyGroupContactsParams {
  tenantID: string | number | undefined;
  groupID: string | number | undefined;
}
export const getPropertyGroupContacts = ({
  tenantID,
  groupID,
}: GetPropertyGroupContactsParams): Promise<Contact[]> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/propertyGroups/${groupID}/contacts`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Contact[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};
interface GetPropertyContactsParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
}
export const getPropertyContacts = ({
  tenantID,
  propertyID,
}: GetPropertyContactsParams): Promise<Contact[]> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/contacts`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Contact[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};

interface GetPropertyPropertyGroupContactsParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
}
export const getPropertyPropertyGroupContacts = ({
  tenantID,
  propertyID,
}: GetPropertyPropertyGroupContactsParams): Promise<Contact[]> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/propertyGroups/contacts`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Contact[]>(res, 200))
    .catch((e) => {
      logError(e);
      throw e;
    });
};
